/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommJobCardContainerViewProps } from './ecomm-job-card-container';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommJobCardContainerViewProps>}
 */
export class EcommJobCardContainerView extends React.PureComponent<IEcommJobCardContainerViewProps> {
    public render(): JSX.Element | null {
        const { slotItems, title, anchorID, EcommJobCardContainerStyle, EcommJobCardContainerTitleStyle } = this.props;

        if (anchorID) {
            const style = `anchor ` + `${EcommJobCardContainerStyle.className}`;

            return (
                <div id={anchorID} className={style}>
                    <h3 className={EcommJobCardContainerTitleStyle.className}>{title}</h3>
                    {slotItems}
                </div>
            );
        }

        return (
            <div className={EcommJobCardContainerStyle.className}>
                <h3 className={EcommJobCardContainerTitleStyle.className}>{title}</h3>
                {slotItems}
            </div>
        );
    }
}

export default EcommJobCardContainerView;
